import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Edit2, ArrowLeft, Briefcase } from 'react-feather';
import config from '../../../../config';
import CustomizerContext from '../../../../_helper/Customizer';
import '../../sadmin.css';

const formatDate = (s) => {
    if (!s) return '—';
    try {
        return new Date(s).toISOString().split('T')[0];
    } catch {
        return '—';
    }
};

const ConcessionaireDetail = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();
    const { layoutURL } = useContext(CustomizerContext);
    const layout = layoutURL || 'default';

    useEffect(() => {
        if (localStorage.getItem('usertype') !== 'sadmin') {
            alert(t('You are not authorized to view this page'));
            window.history.back();
        }
    }, []);

    const token = localStorage.getItem('sessiontoken');
    const configheader = { headers: { Authorization: `${token}` } };
    const [c, setC] = useState({});
    const [createdBy, setCreatedBy] = useState('—');

    useEffect(() => {
        axios
            .get(`${config.hostname}/concessionaire/${id}`, configheader)
            .then((res) => {
                setC(res.data || {});
                setCreatedBy(res.data?.concessionaire_created_by?.userFirstName || '—');
            })
            .catch((err) => console.error(err));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const goList = () =>
        navigate(`${process.env.PUBLIC_URL}/controlpanel/concessionaire/viewconcessionaire/${layout}`);

    const goEdit = () =>
        navigate(`${process.env.PUBLIC_URL}/controlpanel/concessionaire/editconcessionaire/${id}`);

    return (
        <div className="v3 v3-sadmin">
            <header className="v3-sadmin-hero">
                <div className="v3-sadmin-hero-text">
                    <div className="v3-label">{t('Concessionaire detail')}</div>
                    <h1 className="v3-display v3-sadmin-greeting" style={{ fontSize: 26 }}>
                        {c.concessionaire_name || '—'}
                    </h1>
                    <p className="v3-body v3-sadmin-sub">
                        <span className="v3-sadmin-cell-code" style={{ marginRight: 8 }}>
                            {c.concessionaire_code || '—'}
                        </span>
                        <span className={`v3-sadmin-pill ${c.concessionaire_active ? 'live' : 'off'}`}>
                            {c.concessionaire_active ? t('Active') : t('Inactive')}
                        </span>
                    </p>
                </div>
                <div className="v3-sadmin-hero-actions">
                    <button type="button" className="v3-btn v3-btn-ghost" onClick={goList}>
                        <ArrowLeft size={14} />
                        {t('Back to list')}
                    </button>
                    <button type="button" className="v3-btn v3-btn-primary" onClick={goEdit}>
                        <Edit2 size={14} />
                        {t('Edit')}
                    </button>
                </div>
            </header>

            <section className="v3-card v3-sadmin-form-card">
                <div className="v3-sadmin-kv">
                    <div className="v3-sadmin-kv-item">
                        <span className="v3-sadmin-kv-label">{t('Email')}</span>
                        <span className="v3-sadmin-kv-value">{c.concessionaire_email || '—'}</span>
                    </div>
                    <div className="v3-sadmin-kv-item">
                        <span className="v3-sadmin-kv-label">{t('Phone')}</span>
                        <span className="v3-sadmin-kv-value">{c.concessionaire_phone || '—'}</span>
                    </div>
                    <div className="v3-sadmin-kv-item">
                        <span className="v3-sadmin-kv-label">{t('Username')}</span>
                        <span className="v3-sadmin-kv-value">{c.concessionaire_username || '—'}</span>
                    </div>
                    <div className="v3-sadmin-kv-item">
                        <span className="v3-sadmin-kv-label">{t('Data mode')}</span>
                        <span className="v3-sadmin-kv-value">{c.data_mode || '—'}</span>
                    </div>
                    <div className="v3-sadmin-kv-item">
                        <span className="v3-sadmin-kv-label">{t('License start')}</span>
                        <span className="v3-sadmin-kv-value">{formatDate(c.concessionaire_license_start_date)}</span>
                    </div>
                    <div className="v3-sadmin-kv-item">
                        <span className="v3-sadmin-kv-label">{t('License end')}</span>
                        <span className="v3-sadmin-kv-value">{formatDate(c.concessionaire_license_end_date)}</span>
                    </div>
                    <div className="v3-sadmin-kv-item">
                        <span className="v3-sadmin-kv-label">{t('Created')}</span>
                        <span className="v3-sadmin-kv-value">{formatDate(c.concessionaire_created_Date)}</span>
                    </div>
                    <div className="v3-sadmin-kv-item">
                        <span className="v3-sadmin-kv-label">{t('Created by')}</span>
                        <span className="v3-sadmin-kv-value">{createdBy}</span>
                    </div>
                    <div className="v3-sadmin-kv-item">
                        <span className="v3-sadmin-kv-label">{t('Audit required')}</span>
                        <span className="v3-sadmin-kv-value">
                            {c.audit_required ? (
                                <span className="v3-sadmin-pill warn">{t('Required · {{tolerance}}%', { tolerance: c.audit_tolerance ?? 0 })}</span>
                            ) : (
                                <span className="v3-sadmin-pill off">{t('Not required')}</span>
                            )}
                        </span>
                    </div>
                    <div className="v3-sadmin-kv-item" style={{ gridColumn: '1 / -1' }}>
                        <span className="v3-sadmin-kv-label">{t('Address')}</span>
                        <span className="v3-sadmin-kv-value" style={{ minHeight: 64 }}>
                            {c.concessionaire_address || '—'}
                        </span>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ConcessionaireDetail;
